<template>
	<div class="flex flex-col source-li">
		<h5 class="px-2">
			{{ source.name }}({{parseInt(volume.toFixed(2)*100)}})
		</h5>
		<div class="flex">
			<input
				v-model="volume"
				class="w-full flex-1 w-full mx-2"
				:class="source.muted ? 'volumeMute' : 'volumeUp'"
				type="range"
				min="0"
				max="1"
				step="0.01"
			>	
	<!-- 		<div style="width: 200px;" v-if="!isNaN(volume)">
				<el-slider v-model="volume" :min='0' :max="100" :step='0.0001'></el-slider>
			</div> -->
		
			<div
			class="button buttonwap"
			:class="[source.muted ? 'button-muted' : 'button-success']"
			@click="toggleMute({source: source.name, mute: !source.muted})">
				
				<div>
					<FontAwesomeIcon
						:icon="source.muted ? 'volume-mute' : 'volume-up'"
						fixed-width
					/>
				</div>
			</div>
			
			
		</div>
	</div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
	props: {
		source: {
			type: Object,
			required: true
		}
	},
	data() {
		return{
			
		}
	},
	computed: {
		volume: {
			get({source: {volume}}) {
				
				return Math.sqrt(volume)
			},
			set(volume) {
				this.setVolume({
					source: this.source.name,
					volume: volume ** 2
				})
			}
		}
	},
	methods: {
		...mapActions('obs', {
			setVolume: 'sources/volume',
			toggleMute: 'sources/mute'
		})
	}

}
</script>

<style type="text/css">
	
	
	.volumeUp{
		
	}
</style>
